export default "__VITE_ASSET__69168442__"